import { type FragmentType, graphql } from '~/lib/graphql'

export const SharePlanFragment = graphql(/* GraphQL */ `
  fragment SharePlanFragment on Plan {
    planId
    additionalContents
    restrictions
    course {
      name
    }
    restaurant {
      restaurantId
      name
    }
  }
`)

export type SharePlanProps = {
  plan: FragmentType<typeof SharePlanFragment>
}
